import React, { Fragment, useEffect, useState } from 'react';
import AdminBuilderService from '../../../API/Services/AdminService/AdminBuilderService';
import { useNavigate } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import DatePicker from "react-datepicker";
import { Form } from "react-bootstrap";
import { Button } from 'react-bootstrap';
import AdminClosingService from '../../../API/Services/AdminService/AdminClosingService';
import Modal from "react-bootstrap/Modal";
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { Tooltip } from 'react-tooltip';
import LazySubdivisionMultiSelect from "../../components/LazySubdivisionMultiSelect";

const FilterClosings = () => {
    const navigate = useNavigate();

    const [builderListDropDown, setBuilderListDropDown] = useState([]);
    const [selectedBuilderNameByFilter, setSelectedBuilderNameByFilter] = useState([]);
    const [masterPlanDropDownList, setMasterPlanDropDownList] = useState([]);
    const [gasProviderDropDown, setGasProviderDropDown] = useState([]);
    const [selectedBuilderIDByFilter, setSelectedBuilderIDByFilter] = useState([]);
    const [selectedSubdivisionNameByFilter, setSelectedSubdivisionNameByFilter] = useState([]);
    const [lenderList, setLenderList] = useState([]);
    const [seletctedLenderByFilter, setSelectedLenderByFilter] = useState([]);
    const [productTypeStatusByFilter, setProductTypeStatusByFilter] = useState([]);
    const [selectedAreaByFilter, setSelectedAreaByFilter] = useState([]);
    const [selectedMasterPlanByFilter, setSelectedMasterPlanByFilter] = useState([]);
    const [selectedAgeByFilter, setSelectedAgeByFilter] = useState([]);
    const [selectedSingleByFilter, setSelectedSingleByFilter] = useState([]);
    const [seletctedGasProviderByFilter, setSelectedGasProviderByFilter] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [message, setMessage] = useState(false);
    const handlePopupClose = () => setShowPopup(false);
    const [filterQuery, setFilterQuery] = useState({
        from: localStorage.getItem("from_Closing") ? JSON.parse(localStorage.getItem("from_Closing")) : "",
        to: localStorage.getItem("to_Closing") ? JSON.parse(localStorage.getItem("to_Closing")) : "",
        document: localStorage.getItem("document_Closing") ? JSON.parse(localStorage.getItem("document_Closing")) : "",
        builder_name: localStorage.getItem("builder_name_Closing") ? JSON.parse(localStorage.getItem("builder_name_Closing")) : "",
        subdivision_name: localStorage.getItem("subdivision_name_Closing") ? JSON.parse(localStorage.getItem("subdivision_name_Closing")) : "",
        closingprice: localStorage.getItem("closingprice_Closing") ? JSON.parse(localStorage.getItem("closingprice_Closing")) : "",
        address: localStorage.getItem("address_Closing") ? JSON.parse(localStorage.getItem("address_Closing")) : "",
        parcel: localStorage.getItem("parcel_Closing") ? JSON.parse(localStorage.getItem("parcel_Closing")) : "",
        sellerleagal: localStorage.getItem("sellerleagal_Closing") ? JSON.parse(localStorage.getItem("sellerleagal_Closing")) : "",
        buyer: localStorage.getItem("buyer_Closing") ? JSON.parse(localStorage.getItem("buyer_Closing")) : "",
        lender_name: localStorage.getItem("lender_name_Closing") ? JSON.parse(localStorage.getItem("lender_name_Closing")) : "",
        loanamount: localStorage.getItem("loanamount_Closing") ? JSON.parse(localStorage.getItem("loanamount_Closing")) : "",
        product_type: localStorage.getItem("product_type_Closing") ? JSON.parse(localStorage.getItem("product_type_Closing")) : "",
        area: localStorage.getItem("area_Closing") ? JSON.parse(localStorage.getItem("area_Closing")) : "",
        masterplan_id: localStorage.getItem("masterplan_id_Closing") ? JSON.parse(localStorage.getItem("masterplan_id_Closing")) : "",
        zipcode: localStorage.getItem("zipcode_Closing") ? JSON.parse(localStorage.getItem("zipcode_Closing")) : "",
        lotwidth: localStorage.getItem("lotwidth_Closing") ? JSON.parse(localStorage.getItem("lotwidth_Closing")) : "",
        lotsize: localStorage.getItem("lotsize_Closing") ? JSON.parse(localStorage.getItem("lotsize_Closing")) : "",
        age: localStorage.getItem("age_Closing") ? JSON.parse(localStorage.getItem("age_Closing")) : "",
        single: localStorage.getItem("single_Closing") ? JSON.parse(localStorage.getItem("single_Closing")) : "",
        gasprovider: localStorage.getItem("gasprovider_Closing") ? JSON.parse(localStorage.getItem("gasprovider_Closing")) : "",
    });

    useEffect(() => {
        if(localStorage.getItem("selectedBuilderNameByFilter_Closing")) {
            const selectedBuilderName = JSON.parse(localStorage.getItem("selectedBuilderNameByFilter_Closing"));
            handleSelectBuilderNameChange(selectedBuilderName);
        }
        if(localStorage.getItem("selectedSubdivisionNameByFilter_Closing")) {
          const selectedSubdivisionName = JSON.parse(localStorage.getItem("selectedSubdivisionNameByFilter_Closing"));
          handleSelectSubdivisionNameChange(selectedSubdivisionName);
        }
        if(localStorage.getItem("seletctedLenderByFilter_Closing")) {
            const seletctedLender = JSON.parse(localStorage.getItem("seletctedLenderByFilter_Closing"));
            handleSelectLenderChange(seletctedLender);
        }
        if(localStorage.getItem("productTypeStatusByFilter_Closing")) {
            const productTypeStatus = JSON.parse(localStorage.getItem("productTypeStatusByFilter_Closing"));
            handleSelectProductTypeChange(productTypeStatus);
        }
        if(localStorage.getItem("selectedAreaByFilter_Closing")) {
            const selectedArea = JSON.parse(localStorage.getItem("selectedAreaByFilter_Closing"));
            handleSelectAreaChange(selectedArea);
        }
        if(localStorage.getItem("selectedMasterPlanByFilter_Closing")) {
            const selectedMasterPlan = JSON.parse(localStorage.getItem("selectedMasterPlanByFilter_Closing"));
            handleSelectMasterPlanChange(selectedMasterPlan);
        }
        if(localStorage.getItem("selectedAgeByFilter_Closing")) {
            const selectedAge = JSON.parse(localStorage.getItem("selectedAgeByFilter_Closing"));
            handleSelectAgeChange(selectedAge);
        }
        if(localStorage.getItem("selectedSingleByFilter_Closing")) {
            const selectedSingle = JSON.parse(localStorage.getItem("selectedSingleByFilter_Closing"));
            handleSelectSingleChange(selectedSingle);
        }
        if (localStorage.getItem("seletctedGasProviderByFilter_Closing")) {
            const seletctedGasProvider = JSON.parse(localStorage.getItem("seletctedGasProviderByFilter_Closing"));
            handleGasProviderChange(seletctedGasProvider);
        }
    }, []);

    useEffect(() => {
        if (localStorage.getItem("usertoken")) {
            GetBuilderDropDownList();
            GetMasterPlanDropDownList();
            GetGasProviderDropDownList();
            GetLenderList();
        } else {
            navigate("/");
        }
    }, []);

    useEffect(() => {
        if (selectedSubdivisionNameByFilter?.length === 0) {
            setFilterQuery(prevState => ({
                ...prevState,
                subdivision_name: ""
            }));
        }
    }, [selectedSubdivisionNameByFilter]);

    useEffect(() => {
        setSearchQuery(filterString());
    }, [filterQuery]);

    const filterString = () => {
        const queryString = Object.keys(filterQuery)
            .map(
                (key) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(filterQuery[key])}`
            )
            .join("&");

        return queryString ? `&${queryString}` : "";
    };

    const GetLenderList = async () => {
        try {
            let response = await AdminClosingService.lender()
            let responseData = await response.json()
            const formattedData = responseData.map((lender) => ({
                label: lender.lender,
                value: lender.lender,
            }));
            setLenderList(formattedData)
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
            }
        }
    };

    const GetBuilderDropDownList = async () => {
        try {
            const response = await AdminBuilderService.builderDropDown();
            const responseData = await response.json();
            const formattedData = responseData.map((builder) => ({
                label: builder.name,
                value: builder.id,
            }));
            setBuilderListDropDown(formattedData);
        } catch (error) {
            if (error.name === "HTTPError") {
                const errorJson = await error.response.json();
            }
        }
    };

    const GetMasterPlanDropDownList = async () => {
        try {
            const response = await AdminBuilderService.masterPlanDropDown();
            const responseData = await response.json();
            const formattedData = responseData.map((masterPlan) => ({
                label: masterPlan.label,
                value: masterPlan.value,
            }));
            setMasterPlanDropDownList(formattedData);
        } catch (error) {
            if (error.name === "HTTPError") {
                const errorJson = await error.response.json();
            }
        }
    };

    const GetGasProviderDropDownList = async () => {
    try {
      const response = await AdminBuilderService.gasProviderDropDown();
      const responseData = await response.json();
      const formattedData = responseData.map((gas_provider) => ({
        label: gas_provider.label,
        value: gas_provider.value,
      }));
      setGasProviderDropDown(formattedData);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

    const HandlePopupDetailClick = (e) => {
        setShowPopup(true);
    };

    useEffect(() => {
        if (filterQuery.from == "" || filterQuery.to == "") {
            if(localStorage.getItem("setClosingFilter") == "true") {
                setShowPopup(true);
                setMessage("Please select date.");
                localStorage.removeItem("setClosingFilter");
                return;
            }
        } else {
            if(localStorage.getItem("setClosingFilter") == "true") {
                if((searchQuery == "") || (searchQuery == "&from=&to=&document=&builder_name=&subdivision_name=&closingprice=&address=&parcel=&sellerleagal=&buyer=&lender_name=&loanamount=&product_type=&area=&masterplan_id=&zipcode=&lotwidth=&lotsize=&age=&single=&gasprovider=")){
                    return;
                } else {
                    // let startDate = moment(filterQuery.from);
                    // let endDate = moment(filterQuery.to);
                    // let days = endDate.diff(startDate, 'days', true);
                    // let totaldays = Math.ceil(days) + 1;
                    // if (totaldays < 367) {
                        navigate("/closingsalelist");
                        localStorage.setItem("selectedBuilderNameByFilter_Closing", JSON.stringify(selectedBuilderNameByFilter));
                        localStorage.setItem("selectedSubdivisionNameByFilter_Closing", JSON.stringify(selectedSubdivisionNameByFilter));
                        localStorage.setItem("seletctedLenderByFilter_Closing", JSON.stringify(seletctedLenderByFilter));
                        localStorage.setItem("productTypeStatusByFilter_Closing", JSON.stringify(productTypeStatusByFilter));
                        localStorage.setItem("selectedAreaByFilter_Closing", JSON.stringify(selectedAreaByFilter));
                        localStorage.setItem("selectedMasterPlanByFilter_Closing", JSON.stringify(selectedMasterPlanByFilter));
                        localStorage.setItem("selectedAgeByFilter_Closing", JSON.stringify(selectedAgeByFilter));
                        localStorage.setItem("selectedSingleByFilter_Closing", JSON.stringify(selectedSingleByFilter));
                        localStorage.setItem("seletctedGasProviderByFilter_Closing", JSON.stringify(seletctedGasProviderByFilter));
                        localStorage.setItem("from_Closing", JSON.stringify(filterQuery.from));
                        localStorage.setItem("to_Closing", JSON.stringify(filterQuery.to));
                        localStorage.setItem("document_Closing", JSON.stringify(filterQuery.document));
                        localStorage.setItem("builder_name_Closing", JSON.stringify(filterQuery.builder_name));
                        localStorage.setItem("subdivision_name_Closing", JSON.stringify(filterQuery.subdivision_name));
                        localStorage.setItem("closingprice_Closing", JSON.stringify(filterQuery.closingprice));
                        localStorage.setItem("address_Closing", JSON.stringify(filterQuery.address));
                        localStorage.setItem("parcel_Closing", JSON.stringify(filterQuery.parcel));
                        localStorage.setItem("sellerleagal_Closing", JSON.stringify(filterQuery.sellerleagal));
                        localStorage.setItem("buyer_Closing", JSON.stringify(filterQuery.buyer));
                        localStorage.setItem("lender_name_Closing", JSON.stringify(filterQuery.lender_name));
                        localStorage.setItem("loanamount_Closing", JSON.stringify(filterQuery.loanamount));
                        localStorage.setItem("product_type_Closing", JSON.stringify(filterQuery.product_type));
                        localStorage.setItem("area_Closing", JSON.stringify(filterQuery.area));
                        localStorage.setItem("masterplan_id_Closing", JSON.stringify(filterQuery.masterplan_id));
                        localStorage.setItem("zipcode_Closing", JSON.stringify(filterQuery.zipcode));
                        localStorage.setItem("lotwidth_Closing", JSON.stringify(filterQuery.lotwidth));
                        localStorage.setItem("lotsize_Closing", JSON.stringify(filterQuery.lotsize));
                        localStorage.setItem("age_Closing", JSON.stringify(filterQuery.age));
                        localStorage.setItem("single_Closing", JSON.stringify(filterQuery.single));
                        localStorage.setItem("gasprovider_Closing", JSON.stringify(filterQuery.gasprovider));
                        localStorage.setItem("searchQueryByClosingsFilter", JSON.stringify(searchQuery.replace(/^"",|,""$/g, '')));
                    // } else {
                    //     setShowPopup(true);
                    //     setMessage("Please select date between 366 days.");
                    //     localStorage.removeItem("setClosingFilter");
                    //     return;
                    // }
                }
            }
        }
    }, [searchQuery]);

    const HandleFilterForm = (e) => {
        if (filterQuery.from == "" || filterQuery.to == "") {
            setShowPopup(true);
            if(filterQuery.from == "" && filterQuery.to == "") {
                setMessage("Please select from and to date.");
            } else if (filterQuery.from == "") {
                setMessage("Please select from date.");
            } else if (filterQuery.to == "") {
                setMessage("Please select to date.");
            }
            return;
        } else {
            // let startDate = moment(filterQuery.from);
            // let endDate = moment(filterQuery.to);
            // let days = endDate.diff(startDate, 'days', true);
            // let totaldays = Math.ceil(days) + 1;
            // if (totaldays < 367) {
                e.preventDefault();
                navigate("/closingsalelist");
                localStorage.setItem("selectedBuilderNameByFilter_Closing", JSON.stringify(selectedBuilderNameByFilter));
                localStorage.setItem("selectedSubdivisionNameByFilter_Closing", JSON.stringify(selectedSubdivisionNameByFilter));
                localStorage.setItem("seletctedLenderByFilter_Closing", JSON.stringify(seletctedLenderByFilter));
                localStorage.setItem("productTypeStatusByFilter_Closing", JSON.stringify(productTypeStatusByFilter));
                localStorage.setItem("selectedAreaByFilter_Closing", JSON.stringify(selectedAreaByFilter));
                localStorage.setItem("selectedMasterPlanByFilter_Closing", JSON.stringify(selectedMasterPlanByFilter));
                localStorage.setItem("selectedAgeByFilter_Closing", JSON.stringify(selectedAgeByFilter));
                localStorage.setItem("selectedSingleByFilter_Closing", JSON.stringify(selectedSingleByFilter));
                localStorage.setItem("seletctedGasProviderByFilter_Closing", JSON.stringify(seletctedGasProviderByFilter));
                localStorage.setItem("from_Closing", JSON.stringify(filterQuery.from));
                localStorage.setItem("to_Closing", JSON.stringify(filterQuery.to));
                localStorage.setItem("document_Closing", JSON.stringify(filterQuery.document));
                localStorage.setItem("builder_name_Closing", JSON.stringify(filterQuery.builder_name));
                localStorage.setItem("subdivision_name_Closing", JSON.stringify(filterQuery.subdivision_name));
                localStorage.setItem("closingprice_Closing", JSON.stringify(filterQuery.closingprice));
                localStorage.setItem("address_Closing", JSON.stringify(filterQuery.address));
                localStorage.setItem("parcel_Closing", JSON.stringify(filterQuery.parcel));
                localStorage.setItem("sellerleagal_Closing", JSON.stringify(filterQuery.sellerleagal));
                localStorage.setItem("buyer_Closing", JSON.stringify(filterQuery.buyer));
                localStorage.setItem("lender_name_Closing", JSON.stringify(filterQuery.lender_name));
                localStorage.setItem("loanamount_Closing", JSON.stringify(filterQuery.loanamount));
                localStorage.setItem("product_type_Closing", JSON.stringify(filterQuery.product_type));
                localStorage.setItem("area_Closing", JSON.stringify(filterQuery.area));
                localStorage.setItem("masterplan_id_Closing", JSON.stringify(filterQuery.masterplan_id));
                localStorage.setItem("zipcode_Closing", JSON.stringify(filterQuery.zipcode));
                localStorage.setItem("lotwidth_Closing", JSON.stringify(filterQuery.lotwidth));
                localStorage.setItem("lotsize_Closing", JSON.stringify(filterQuery.lotsize));
                localStorage.setItem("age_Closing", JSON.stringify(filterQuery.age));
                localStorage.setItem("single_Closing", JSON.stringify(filterQuery.single));
                localStorage.setItem("gasprovider_Closing", JSON.stringify(filterQuery.gasprovider));
                localStorage.setItem("searchQueryByClosingsFilter", JSON.stringify(searchQuery.replace(/^"",|,""$/g, '')));
                localStorage.setItem("setClosingFilter", true);
            // } else {
            //     setShowPopup(true);
            //     setMessage("Please select date between 366 days.");
            //     return;
            // }
        }
    };

    const handleFilterDateFrom = (date) => {
        if (date) {
            const formattedDate = date.toLocaleDateString('en-US');

            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                from: formattedDate,
            }));
        } else {
            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                from: '',
            }));
        }
    };

    const handleFilterDateTo = (date) => {
        if (date) {
            const formattedDate = date.toLocaleDateString('en-US');

            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                to: formattedDate,
            }));
        } else {
            setFilterQuery((prevFilterQuery) => ({
                ...prevFilterQuery,
                to: '',
            }));
        }
    };

    const parseDate = (dateString) => {
        const [month, day, year] = dateString.split('/');
        return new Date(year, month - 1, day);
    };

    const HandleFilter = (e) => {
        const { name, value } = e.target;
        setFilterQuery((prevFilterQuery) => ({
            ...prevFilterQuery,
            [name]: value,
        }));
    };

    const handleSelectBuilderNameChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.label).join(', ');
        const selectedValues = selectedItems.map(item => item.value);
        setSelectedBuilderNameByFilter(selectedItems);
        setSelectedBuilderIDByFilter(selectedValues);
        setFilterQuery(prevState => ({
            ...prevState,
            builder_name: selectedNames
        }));
    };

    const handleSelectSubdivisionNameChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.label).join(', ');

        setSelectedSubdivisionNameByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            subdivision_name: selectedNames
        }));
    };

    const handleSelectLenderChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');

        setSelectedLenderByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            lender: selectedValues
        }));
    };

    const handleSelectProductTypeChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.value).join(', ');

        setProductTypeStatusByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            product_type: selectedNames
        }));
    };

    const handleSelectAreaChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');

        setSelectedAreaByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            area: selectedValues
        }));
    };

    const handleSelectMasterPlanChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');

        setSelectedMasterPlanByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            masterplan_id: selectedValues
        }));
    };

    const handleSelectAgeChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.value).join(', ');

        setSelectedAgeByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            age: selectedNames
        }));
    };

    const handleSelectSingleChange = (selectedItems) => {
        const selectedNames = selectedItems.map(item => item.value).join(', ');

        setSelectedSingleByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            single: selectedNames
        }));
    };

    const productTypeOptions = [
        { value: "DET", label: "DET" },
        { value: "ATT", label: "ATT" },
        { value: "HR", label: "HR" },
        { value: "AC", label: "AC" }
    ];

    const areaOption = [
        { value: "BC", label: "BC" },
        { value: "E", label: "E" },
        { value: "H", label: "H" },
        { value: "IS", label: "IS" },
        { value: "L", label: "L" },
        { value: "MSQ", label: "MSQ" },
        { value: "MV", label: "MV" },
        { value: "NLV", label: "NLV" },
        { value: "NW", label: "NW" },
        { value: "P", label: "P" },
        { value: "SO", label: "SO" },
        { value: "SW", label: "SW" }
    ];

    const ageOptions = [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" }
    ];

    const singleOptions = [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" }
    ];

    const handleGasProviderChange = (selectedItems) => {
        const selectedValues = selectedItems.map(item => item.value).join(', ');
        setSelectedGasProviderByFilter(selectedItems);
        setFilterQuery(prevState => ({
            ...prevState,
            gasprovider: selectedValues
        }));
    };

    const HandleCancelFilter = () => {
        setFilterQuery({
            from: "",
            to: "",
            document: "",
            builder_name: "",
            subdivision_name: "",
            closingprice: "",
            address: "",
            parcel: "",
            sellerleagal: "",
            buyer: "",
            lender_name: "",
            loanamount: "",
            product_type: "",
            area: "",
            masterplan_id: "",
            zipcode: "",
            lotwidth: "",
            lotsize: "",
            age: "",
            single: "",
            gasprovider: "",
        });
        setSelectedBuilderNameByFilter([]);
        setSelectedSubdivisionNameByFilter([]);
        setSelectedLenderByFilter([]);
        setProductTypeStatusByFilter([]);
        setSelectedAreaByFilter([]);
        setSelectedMasterPlanByFilter([]);
        setSelectedAgeByFilter([]);
        setSelectedSingleByFilter([]);
        setSelectedGasProviderByFilter([]);
        setSelectedBuilderIDByFilter([]);
    };

    return (
        <Fragment>
            <div className="container mt-5">
                <h2>Filter Closings</h2>
                <form onSubmit={HandleFilterForm}>
                    <div className="row">
                        <div className="col-md-3 mt-3">
                            <label className="form-label">From:{" "}
                                <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                name="from"
                                className="form-control"
                                selected={filterQuery.from ? parseDate(filterQuery.from) : null}
                                onChange={handleFilterDateFrom}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="mm/dd/yyyy"
                            />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">To:{" "}
                                <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                name="to"
                                className="form-control"
                                selected={filterQuery.to ? parseDate(filterQuery.to) : null}
                                onChange={handleFilterDateTo}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="mm/dd/yyyy"
                            />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">DOC:{" "}
                                <div className="btn-tooltip" id="document">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                    <Tooltip
                                      anchorSelect="#document"
                                      style={{ zIndex: 999 }}
                                      content={<>Clark County Document <br/> Number</>}
                                    />
                                </div>
                            </label>
                            <input name="document" value={filterQuery.document} className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">BUILDER NAME:{" "}</label>
                            <Form.Group controlId="tournamentList">
                                <MultiSelect
                                    name="builder_name"
                                    options={builderListDropDown}
                                    value={selectedBuilderNameByFilter}
                                    onChange={handleSelectBuilderNameChange}
                                    placeholder={"Select Builder Name"}
                                    hasSelectAll={true}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">SUBDIVISION NAME:{" "}</label>
                            <Form.Group controlId="tournamentList">
                                <LazySubdivisionMultiSelect
                                    builderIds={selectedBuilderIDByFilter}
                                    name="subdivision_name"
                                    value={selectedSubdivisionNameByFilter}
                                    onChange={handleSelectSubdivisionNameChange}
                                    placeholder={"Select Subdivision Name"}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">CLOSING PRICE:{" "}</label>
                            <input name="closingprice" value={filterQuery.closingprice} className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">ADDRESS:{" "}</label>
                            <input name="address" value={filterQuery.address} className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">PARCEL NUMBER:{" "}</label>
                            <input value={filterQuery.parcel} name="parcel" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">SELLER LEGAL NAME:{" "}</label>
                            <input value={filterQuery.sellerleagal} name="sellerleagal" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">BUYER NAME:{" "}</label>
                            <input value={filterQuery.buyer} name="buyer" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">LENDER:{" "}</label>
                            <Form.Group controlId="tournamentList">
                                <MultiSelect
                                    name="lender_name"
                                    options={lenderList}
                                    value={seletctedLenderByFilter}
                                    onChange={handleSelectLenderChange}
                                    placeholder={"Select Lender"}
                                    hasSelectAll={true}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">LOAN AMOUNT:{" "}</label>
                            <input value={filterQuery.loanamount} name="loanamount" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">PRODUCT TYPE:{" "}
                                <div className="btn-tooltip" id="product_type">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                        <Tooltip
                                          anchorSelect="#product_type"
                                          style={{ zIndex: 999 }}
                                          content={<>DET: Single Family Detached <br/> ATT: Attached (e.g., Condo, Townhome, Duplex) <br/> HR: High Rise</>}
                                        />
                                </div>
                            </label>
                            <MultiSelect
                                name="product_type"
                                options={productTypeOptions}
                                value={productTypeStatusByFilter}
                                onChange={handleSelectProductTypeChange}
                                placeholder="Select Prodcut Type"
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">AREA:{" "}
                                <div className="btn-tooltip" id="area">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                        <Tooltip
                                          anchorSelect="#area"
                                          clickable={true} 
                                          style={{ zIndex: 999 }}
                                          content={
                                            <> 
                                            See our Sub-Market<br /> Area Map:{" "}                                 
                                                <a
                                                    href="https://www.homebuildersresearch.com/images/misc/sub_market_areas.png"
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >                      
                                                View Map
                                                </a>
                                            </>}
                                        />
                                </div>
                            </label>
                            <MultiSelect
                                name="area"
                                options={areaOption}
                                value={selectedAreaByFilter}
                                onChange={handleSelectAreaChange}
                                placeholder="Select Area"
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">MASTERPLAN:{" "}</label>
                            <MultiSelect
                                name="masterplan_id"
                                options={masterPlanDropDownList}
                                value={selectedMasterPlanByFilter}
                                onChange={handleSelectMasterPlanChange}
                                placeholder="Select Area"
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">ZIP CODE:{" "}</label>
                            <input 
                                type="text" 
                                name="zipcode" 
                                value={filterQuery.zipcode} 
                                className="form-control" 
                                onChange={HandleFilter} 
                                pattern="[0-9, ]*"
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9, ]/g, '');
                                }}
                            />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">LOT WIDTH:{" "}
                                <div className="btn-tooltip" id="lotwidth">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                        <Tooltip
                                          anchorSelect="#lotwidth"
                                          style={{ zIndex: 999 }}
                                          content={<>Approximate average lot width</>}
                                        />
                                </div>                                
                            </label>
                            <input value={filterQuery.lotwidth} name="lotwidth" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">LOT SIZE:{" "}
                                <div className="btn-tooltip" id="lotsize">
                                    <IoMdInformationCircleOutline height={50} width={50} />
                                        <Tooltip
                                          anchorSelect="#lotsize"
                                          style={{ zIndex: 999 }}
                                          content={<>Approximate average lot size (sqft)</>}
                                        />
                                </div>                                
                            </label>
                            <input value={filterQuery.lotsize} name="lotsize" className="form-control" onChange={HandleFilter} />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">AGE RESTRICTED:{" "}</label>
                            <MultiSelect
                                name="age"
                                options={ageOptions}
                                value={selectedAgeByFilter}
                                onChange={handleSelectAgeChange}
                                placeholder={"Select Age"}
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3">
                            <label className="form-label">ALL SINGLE STORY:{" "}</label>
                            <MultiSelect
                                name="single"
                                options={singleOptions}
                                value={selectedSingleByFilter}
                                onChange={handleSelectSingleChange}
                                placeholder={"Select Single"}
                                hasSelectAll={true}
                            />
                        </div>
                        <div className="col-md-3 mt-3 mb-3">
                            <label className="form-label">GAS PROVIDER:</label>
                            <MultiSelect
                                name="gasprovider"
                                options={gasProviderDropDown}
                                value={seletctedGasProviderByFilter}
                                onChange={handleGasProviderChange}
                                placeholder="Select Gas Provider"
                                hasSelectAll={true}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="d-flex justify-content-between">
                        <Button
                            className="btn-sm"
                            onClick={HandleCancelFilter}
                            variant="secondary"
                        >
                            Reset
                        </Button>
                        <Button
                            className="btn-sm"
                            onClick={HandleFilterForm}
                            variant="primary"
                        >
                            Filter
                        </Button>
                    </div>
                </form>
            </div>

            {/* Popup */}
            <Modal show={showPopup} onHide={HandlePopupDetailClick}>
                <Modal.Header handlePopupClose>
                    <Modal.Title>Alert</Modal.Title>
                    <button
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => handlePopupClose()}
                    ></button>
                </Modal.Header>
                <Modal.Body>
                    {message}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handlePopupClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default FilterClosings;
